import React from 'react';
import { connect } from 'react-redux';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import CreateAction from '@/components/ribbon-actions/CreateAction';
import { refreshRoles, showDefaultRole, showSaveRole } from '../actions';

const RolesActions = ({
  allowChangeDefault,
  allowCreate,
  allowRefresh,
  category,
  newRole,
  readStatus,
  refresh,
  showChangeDefault,
}) => (
  <>
    {allowCreate && (<CreateAction onClick={newRole} />)}
    {allowRefresh && (<RefreshActionMenu onClick={() => refresh(category, 1)} readStatus={readStatus} />)}
    {allowChangeDefault && (
    <RibbonMenu
      name="default-role"
      icon="cog"
      message="configurations.default.ribbon.action"
      onClick={showChangeDefault}
    />
    )}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions } },
  roles: { roles },
}, { category }) => ({
  allowRefresh: permissions.roles.read,
  allowCreate: permissions.roles.create,
  allowChangeDefault: permissions.configurations.update,
  readStatus: roles[category].readStatus,
});

const mapDispatchToProps = {
  refresh: refreshRoles,
  newRole: () => showSaveRole(null, null),
  showChangeDefault: showDefaultRole,
};

export default connect(mapStateToProps, mapDispatchToProps)(RolesActions);
